import { render, staticRenderFns } from "./AddOrderTable.vue?vue&type=template&id=48eb4667&"
import script from "./AddOrderTable.vue?vue&type=script&lang=js&"
export * from "./AddOrderTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports